module.exports = __webpack_public_path__ + "static/media/pieve_piazza.9c36379b.png";